module.exports = __webpack_public_path__ + "img/Intranet_Head_old_2.dc6c6759.png";